import { render, staticRenderFns } from "./GeneratedHistoryPopup.vue?vue&type=template&id=38d91796&scoped=true"
import script from "./GeneratedHistoryPopup.vue?vue&type=script&lang=js"
export * from "./GeneratedHistoryPopup.vue?vue&type=script&lang=js"
import style0 from "./GeneratedHistoryPopup.vue?vue&type=style&index=0&id=38d91796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d91796",
  null
  
)

export default component.exports